import React from "react";
import "./privacy-policy.m.css";
const PrivacyPolicy = () => {
  return (
    <div styleName="container">
      <div styleName="hero-image">
        <img src="https://s3-alpha-sig.figma.com/img/1c4c/1c56/077c2920d9ec8655d049089c2dfacbc7?Expires=1743984000&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=dG6Kpz7yVoaNo4Xqy0f~Zu-YtharChBXABuKbes3TgZwcP~mkvxCeaaex5IesfogwariSqGsTKGdpeHwW2nBJmzm0ZHLRjtTsEKkKUq7vcu69Nxva9~fXL1EZ68PXfl0j332mspOqULI57~zbGXa-~kmf40fq631-v3SLbq4BoUbLj5zjXadGFp0G-fA5c2XMg2Dn0obIbafLT0hqVUWtKST3QEGdbogMiF-f0APZbKDEJYuOC2vURfNCxkwy4hRvYN-FQYW52uCc4BHlpFCQ~LoroQkHZaGXqnhHb~wTf6W3j7cfNWpj01HCtMTLKPZCKpn3R71mq9NTsigVulloA__" />
        <h1 styleName="header-one">Tietoturvaselosteet</h1>
      </div>
      <div styleName="lower-container">
      <h2 styleName="asiakas-rekisteri">Asiakasrekisteri</h2>
      <p>
        <strong>Laatimispäivä (viimeisin päivitys):</strong> 6.2.2024
      </p>

      <h2 styleName="header-two">1. Rekisterinpitäjä</h2>
      <p>
        <span styleName="highlight">Kristillinen Media Oy (Radio Dei)</span>, Y-tunnus 1058141-9
      </p>
      <p>Osoite: Mannerheimintie 105, 00280 HELSINKI</p>

      <h2 styleName="header-two">2. Rekisteriasioita hoitava henkilö</h2>
      <p>
        <strong>Lauri Nurminen</strong>
      </p>
      <p styleName="anchor-style">
        Email: <a href="mailto:lauri.nurminen@radiodei.fi">lauri.nurminen@radiodei.fi</a>
      </p>
      <p>Puhelin: 040 731 9321</p>

      <h2 styleName="header-two">3. Rekisterin nimi</h2>
      <p>Kristillinen Media Oy Asiakasrekisteri</p>

      <h2 styleName="header-two">4. Henkilötietojen käsittelyn tarkoitus</h2>
      <p>
        Henkilötietoja käytetään asiakassuhteiden hoitoon, henkilön saamien valtuutuksien seurantaan, mielipide ja
        markkinointitutkimukseen tai muihin näihin rinnastettaviin tietojen taltiointiin ja osoitteellisiin lähetyksiin.
      </p>
      <p>
        Rekisteriin voidaan tallentaa myös yhteistyöhön välttämättömästi liittyviä muita tietoja, kuten asiakkaan
        referenssiasiakkaat.
      </p>

      <h2 styleName="header-two">5. Rekisterin tietosisältö</h2>
      <p>
        Rekisteri sisältää seuraavia tietoja: Yhteystiedot kuten rekisteröidyn nimi, osoite, puhelinnumero,
        sähköpostiosoite, työpaikka, työtehtävä ja koulutus. Työpaikan ja/tai yhteisön tiedot yhteystietoineen,
        rekisteröidyn työtehtävät, osasto, kiinnostuksen kohteet, roolit organisaatiossa. Tieto rekisteröidyn kanssa
        käydyistä keskusteluista ja kirjeenvaihdosta, tiedot asiakaspalautteista, web-lomakkeiden täytöt,
        rekisteröitymiset ja osallistumiset tilaisuuksiin sekä uutiskirjeiden tilaukset. Muiden palveluiden
        markkinointia edistävät tiedot, kuten kielitaito, keskeiset osaamisalueet, halutut asiakassegmentit ja kuva.
      </p>

      <h2 styleName="header-two">6. Henkilötietojen säilytysaika</h2>
      <p>
        Radio Dei säilyttää henkilötietoja asiakasrekisterissä, kunnes rekisteröidyn kanssa olevan asiakassuhteen
        voidaan katsoa päättyneen. Päättymisaika määritellään rekisteröidyn viimeisimmästä palvelukontaktista tai
        yhteydenotosta, johon lisätään <span styleName="highlight">5 vuotta</span>.
      </p>

      <h2 styleName="header-two">7. Säännönmukaiset tietolähteet</h2>
      <p>
        Rekisteröity itse ja rekisteröidyn asiakkuuteen, palveluiden käyttöön, viestintään sekä asiointiin liittyvät
        tapahtumat. Tunnistamis-, varmennus-, osoite-, luottotieto- tai muuta vastaavaa palvelua tarjoava osapuoli.
        Yleisesti saatavilla olevat internet lähteet.
      </p>

      <h2 styleName="header-two">8. Säännönmukaiset tietojen luovutukset ja tietojen siirto EU:n tai Euroopan talousalueen ulkopuolelle</h2>
      <p>
        Radio Dei käyttää rekisterissä olevia henkilötietoja itse eikä luovuta niitä suoramarkkinointitarkoituksiin
        kolmansille osapuolille. Asiakastietojärjestelmää ylläpidetään EU:n tai Euroopan talousalueella sijaitsevilla
        palvelimilla mukaan lukien Sveitsi ja Iso-Britania, mutta tietoja voidaan siirtää myös Euroopan unionin tai
        Euroopan talousalueen ulkopuolelle Yhdysvaltoihin, tietosuojalainsäädännön mukaisesti ja sen asettamissa
        rajoissa.
      </p>
      <h2 styleName="header-two">9. Rekisterin suojauksen periaatteet</h2>
      <p>
        Rekisterin sisältämiin tietoihin pääsevät ja niitä käyttävät vain ne Radio Dein työntekijät, joilla työnsä
        puolesta on siihen oikeus. Järjestelmään sisäänpääsy edellyttää kultakin rekisterin käyttäjältä määriteltyjen
        käyttäjätunnusten ja oikean salasanan syöttämistä. Työntekijöiden kanssa on salassapitosopimus.
      </p>
      <h2 styleName="header-two">10. Rekisteröidyn kielto-oikeus </h2>
      <p>
        Rekisteröidyllä on oikeus kieltää Radio Deitä käsittelemästä häntä itseään koskevia tietoja suoramainontaa ja
        muuta suoramarkkinointia sekä markkina- ja mielipidetutkimusta varten. Kielto tulee tehdä kirjallisesti ja
        osoittaa rekisteriasioista vastaavalle henkilöille tai lähettämällä Radio Dein rekisterissä olevasta osoitteesta
        sähköpostia rekisteriasioita hoitavalle henkilölle kohdan 14 mukaisesti.
      </p>
      <h2 styleName="header-two">11. Rekisteröidyn tarkastusoikeus </h2>
      <p>
        Rekisteröidyllä on oikeus tarkastaa henkilörekisteriin tallennetut itseään koskevat tiedot ja saada niistä
        kopiot. Tarkastuspyyntö tulee lähettää kirjallisesti ja allekirjoitettuna tai Radio Dein rekisterissä olevasta
        osoitteesta sähköpostilla rekisteriasioita hoitavalle henkilölle kohdan 14 mukaisesti
      </p>
      <h2 styleName="header-two">12. Tiedon korjaaminen </h2>
      <p>
        Rekisterinpitäjä oma-aloitteisesti tai rekisteröidyn vaatimuksesta oikaisee, poistaa tai täydentää rekisterissä
        olevan, käsittelyn tarkoituksen kannalta virheellisen, tarpeettoman, puutteellisen tai vanhentuneen
        henkilötiedon. Tarkastusoikeuden toteuttamiseksi ja tiedon korjaamiseksi tulee ottaa kirjallisesti tai
        rekisterissä olevasta sähköpostista yhteyttä kohdan 14 mukaisesti.
      </p>
      <h2 styleName="header-two">13. Rekisteröidyn oikeus tehdä valitus valvontaviranomaiselle </h2>
      <p>
        Rekisteröidyllä on oikeus tehdä valitus toimivaltaiselle valvontaviranomaiselle, jos rekisterinpitäjä ei ole
        noudattanut toiminnassaan soveltuvaa tietosuojasääntelyä.
      </p>
      <h2 styleName="header-two">14. Yhteydenotot</h2>

      <div styleName="contact-box">
        <p>
          <strong>Postiosoite:</strong>
        </p>
        <p>Radio Dei, Mannerheimintie 105, 00280 HELSINKI</p>
        <p>
          <strong>Lähettämällä sähköpostia Radio Dein rekisterissä olevasta sähköpostiosoitteesta osoitteeseen:</strong>
        </p>
        <p styleName="anchor-style">
          <a href="mailto:asiakaspalvelu@radiodei.fi">asiakaspalvelu@radiodei.fi</a>
        </p>
        <p>
          Radio Dei voi tarvittaessa pyytää rekisteröityä täsmentämään pyyntöään kirjallisesti ja rekisteröidyn
          henkilöllisyys voidaan tarpeen vaatiessa varmentaa ennen muihin toimenpiteisiin ryhtymistä.
        </p>
      </div>

      <h2 styleName="header-two">Markkinointirekisteri</h2>
      <p>
        <strong>Laatimispäivä (viimeisin päivitys):</strong> 6.2.2025
      </p>

      <h2 styleName="header-two">1. Rekisterin nimi</h2>
      <p>Kristillinen Media Oy Markkinointirekisteri</p>

      <h2 styleName="header-two">2. Henkilötietojen käsittelyn tarkoitus ja peruste</h2>
      <p>
        Henkilötietojen käsittelyn ensisijaisena perusteena on Radio Dein asiakkaan ja Radio Dein välinen asiakassuhde,
        asiakkaan suostumus, asiakkaan antama toimeksianto tai muu asiallinen yhteys. Henkilötietoja voidaan käsitellä
        seuraavissa käyttötarkoituksissa:
      </p>
      <ul>
        <li>
          Asiakassuhteen, asiakaspalvelun ja niihin liittyvän viestinnän ja markkinoinnin hoitaminen, toteuttaminen,
          kehittäminen ja seuranta.
        </li>
        <li>Asiakaspalautteen ja asiakkaan tyytyväisyystietojen kerääminen ja käsittely</li>
        <li>Markkinatutkimusten ja mielipidekyselyiden toteuttaminen.</li>
      </ul>

      <h2 styleName="header-two">3. Rekisterin tietosisältö</h2>
      <p>
        Rekisteröidystä voidaan tallentaa muun muassa seuraavan kaltaisia tietoja: Nimi, kieli, osoite, puhelinnumero,
        sähköpostiosoite ja muut tarpeelliset yhteystiedot.
      </p>
      <div styleName="contact-box">
      <ul>
        <li>Markkinoinnin ja viestinnän toteutustiedot eri asiointikanavissa.</li>
        <li>
          Rekisteröidyn itse tuottama sisältö kuten asiakaspalaute sekä hänen itsestään antamat lisätiedot kuten
          kyselyt, lisätieto- tai materiaalipyynnöt, kiinnostuksen kohteet tai muut vastaavat tiedot.
        </li>
        <li>Rekisteröidyn toivomia ja käyttämiä palveluita maksutietoineen.</li>
        <li>Tietoa henkilöistä, jotka ovat palvelleet rekisteröityä.</li>
        <li>Kieltoja, rajoituksia, suostumuksia ja muita valintoja.</li>
        <li>Rekisteröidyn liittyminen johonkin yritykseen tai muuhun organisaatioon, kuten työnantajatiedot.</li>
        <li>
          Muita asiakkuuteen liittyviä tietoja, kuten esimerkiksi asiakkaaseen yhdistettävissä oleva verkkosivujen
          käytöstä kerättävä tieto, käyttäjän IP-osoite, käynnin kellonaika, vieraillut sivut, käytetty selaintyyppi
          (esim. Internet Exproler, Firefox), verkko-osoite, josta käyttäjä on tullut verkkosivulle sekä palvelin, jolta
          käyttäjä on tullut verkkosivulle.
        </li>
        <li>Tiedon käsittelyyn liittyviä tietoja, kuten tallennuspäivämäärä ja tietolähde.</li>
      </ul>
      </div>
      <h2 styleName="header-two">4. Henkilötietojen säilytysaika</h2>
      <p>
        Radio Dei säilyttää henkilötietoja asiakasrekisterissä, kunnes rekisteröidyn ja Radio Dein välisen
        asiakassuhteen voidaan katsoa päättyneen. Päättymisaika määritetään rekisteröidyn viimeisimmästä
        palvelukontaktista tai yhteydenotosta, johon lisätään viisi vuotta.
      </p>
      <h2 styleName="header-two">5. Säännönmukaiset tietolähteet</h2>
      <p>Tietoja saadaan ensisijaisesti seuraavista lähteistä:</p>
      <div styleName="contact-box">
      <ul>
        <li>
          rekisteröity itse ja rekisteröidyn asiakkuuteen, palveluiden käyttöön, viestintään sekä asiointiin liittyvät
          tapahtumat.
        </li>
        <li>
          Tunnistamis-, varmennus-, osoite-, päivitys-, luottotieto- tai muuta vastaavaa palvelua tarjoava osapuoli.
        </li>
        <li>Väestörekisterikeskuksen väestötietojärjestelmä ja muut vastaavat, tunnetut järjestelmät.</li>
      </ul>
      </div>
      <h2 styleName="header-two">
        6. Tietojen säännönmukaiset luovutukset ja tietojen siirto Euroopan Unionin tai Euroopan talousalueen
        ulkopuolelle
      </h2>
      <p>
        Asiakastietoja ei luovuteta Radio Dein tai sen lukuun toimivien palveluiden (esim. Kristityt Yhdessä ry.) ja
        viestinnän tuotantoon, kehittämiseen tai ylläpitoon osallistuvien tahojen ulkopuolelle muuten kuin sopimuksen,
        erillisen suostumuksen ja/tai nimenomaisten säädösten mukaan. Asiakastietoja voidaan siirtää Euroopan unionin
        tai Euroopan talousalueen ulkopuolelle Yhdysvaltoihin, tietosuojalainsäädännön mukaisesti ja sen asettamissa
        rajoissa.
      </p>
      <h2 styleName="header-two">7. Kuvaus rekisterin suojauksen periaatteista</h2>
      <p>
        Digitaaliseen aineistoon on pääsy vain siihen oikeutetun työntekijän tai rekisteripalveluja tuottavan
        organisaation valtuuttaman henkilön henkilökohtaisella käyttäjätunnuksella ja salasanalla.
      </p>
      <h2 styleName="header-two">8. Rekisteröidyn oikeus vastustaa henkilötietojen käsittelyä ja suoramarkkinointia. (Kielto-oikeus)</h2>
      <p>
        Rekisteröidyllä on oikeus henkilökohtaiseen erityiseen tilanteeseensa liittyen vastustaa käsittelytoimia, joita
        Radio Dei kohdistaa rekisteröidyn henkilötietoihin siltä osin, kun tietojen käsittelemisen perusteena on Radio
        Dein ja rekisteröidyn välinen asiakassuhde.
      </p>
      <p>
        Rekisteröity voi esittää tietojensa käsittelyn vastustamista koskevan vaatimuksensa tämän tietosuojaselosteen
        kohdan 13 mukaisesti. Rekisteröidyn tulee vaatimuksen yhteydessä yksilöidä se erityinen tilanne, johon perustuen
        hän vastustaa käsittelyä. Yritys voi kieltäytyä toteuttamasta vastustamista koskevaa pyyntöä laissa säädetyin
        perustein. Rekisteröity voi antaa Radio Deille suoramarkkinointia koskevia suostumuksia tai kieltoja
        kanavakohtaisesti.
      </p>
      <h2 styleName="header-two">9. Rekisteröidyn tarkastusoikeus</h2>
      <p>
        Rekisteröidyllä on oikeus tarkastaa, mitä häntä koskevia tietoja Radio Dein asiakasrekisteriin on talletettu.
        Tarkastuspyyntö tulee tehdä tämän tietosuojaselosteen kohdan 13 mukaisesti.
      </p>
      <h2 styleName="header-two">10. Rekisteröidyn oikeus vaatia tiedon oikaisemista, poistamista tai käsittelyn rajoittamista</h2>
      <p>
        Siltä osin kuin rekisteröity tai käyttäjä voi toimia itse, hänen on ilman aiheetonta viivytystä, saatuaan tiedon
        virheestä tai, virheen itse havaittuaan, oma-aloitteisesti tehtävä korjauspyyntö tämän tietosuojaselosteen
        kohdan 13 mukaisesti, jotta Radio Dei voi oikaista, poistaa tai täydentää rekisterissä oleva virheellinen,
        tarpeeton, puutteellinen tai vanhentunut tieto.
      </p>
      <h2 styleName="header-two">11. Yhteydenotot</h2>

      <div styleName="contact-box">
        <p>
          <strong>Postiosoite:</strong>
        </p>
        <p>Radio Dei, Mannerheimintie 105, 00280 HELSINKI</p>
        <p>
          <strong>Lähettämällä sähköpostia Radio Dein rekisterissä olevasta sähköpostiosoitteesta osoitteeseen:</strong>
        </p>
        <p styleName="anchor-style">
          <a href="mailto:asiakaspalvelu@radiodei.fi">asiakaspalvelu@radiodei.fi</a>
        </p>
        <p>
          Radio Dei voi tarvittaessa pyytää rekisteröityä täsmentämään pyyntöään kirjallisesti ja rekisteröidyn
          henkilöllisyys voidaan tarpeen vaatiessa varmentaa ennen muihin toimenpiteisiin ryhtymistä.
        </p>
      </div>
      </div>
    </div>
  );
};
export { PrivacyPolicy };
